import { Component } from '@angular/core';

@Component({
  selector: 'app-shopify-error',
  templateUrl: './shopify-error.component.html',
  styleUrls: ['./shopify-error.component.css']
})
export class ShopifyErrorComponent {

}
